export const buildPaginationWindow = (currentPage: number, totalPages: number, maxVisible = 5): number[] => {
  const visiblePageCount = Math.min(maxVisible, Math.max(0, totalPages));
  const windowStart = Math.min(
    Math.max(0, currentPage - Math.floor(visiblePageCount / 2)),
    totalPages - visiblePageCount,
  );

  return Array.from({ length: visiblePageCount }, (_, index) => windowStart + index);
};
